import './styles.css';
import * as ko from 'knockout'; // Importing Knockout.js
import MainViewModel from './viewModels/MainViewModel';
import './bindings/germanDatepicker'; // German date picker for Schadentag fields
ko.applyBindings(new MainViewModel());
